export default "__VITE_ASSET__Eh3qZ7t1__"